/* eslint-disable comma-dangle, no-alert, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/prop-types, react/sort-comp, space-infix-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Editor = require("../editor.jsx");

var _require = require("../icon-paths.js"),
    iconCircleArrowDown = _require.iconCircleArrowDown,
    iconCircleArrowUp = _require.iconCircleArrowUp,
    iconPlus = _require.iconPlus,
    iconTrash = _require.iconTrash;

var InlineIcon = require("../components/inline-icon.jsx");

var StepControlButton = React.createClass({
    displayName: "StepControlButton",

    render: function render() {
        var _this = this;

        return React.createElement(
            "a",
            {
                href: "#",
                className: "step-control-button " + "simple-button " + "simple-button--small " + "orange",
                onClick: function onClick(e) {
                    e.preventDefault();
                    _this.props.onClick();
                }
            },
            React.createElement(InlineIcon, this.props.icon)
        );
    }
});

var SequenceEditor = React.createClass({
    displayName: "SequenceEditor",

    propTypes: {
        json: React.PropTypes.arrayOf(React.PropTypes.shape({
            content: React.PropTypes.string,
            widgets: React.PropTypes.object,
            images: React.PropTypes.object
        })),
        apiOptions: ApiOptions.propTypes,
        onChange: React.PropTypes.func.isRequired
    },

    getDefaultProps: function getDefaultProps() {
        return {
            json: [{
                content: "",
                widgets: {},
                images: {}
            }]
        };
    },

    render: function render() {
        var _this2 = this;

        return React.createElement(
            "div",
            { className: "perseus-sequence-editor" },
            _.map(this.props.json, function (json, i) {
                return React.createElement(
                    "div",
                    { key: i },
                    "Step ",
                    i + 1,
                    React.createElement(
                        "div",
                        {
                            style: {
                                display: "inline-block",
                                float: "right"
                            }
                        },
                        i + 1 < _this2.props.json.length && React.createElement(StepControlButton, {
                            icon: iconCircleArrowDown,
                            onClick: function onClick() {
                                _this2._handleMoveStepLater(i);
                            }
                        }),
                        i > 0 && React.createElement(StepControlButton, {
                            icon: iconCircleArrowUp,
                            onClick: function onClick() {
                                _this2._handleMoveStepEarlier(i);
                            }
                        }),
                        React.createElement(StepControlButton, {
                            icon: iconTrash,
                            onClick: function onClick() {
                                var msg = "Are you sure you " + "want to remove step " + (i + 1) + "?";
                                if (confirm(msg)) {
                                    _this2._handleRemoveStep(i);
                                }
                            }
                        }),
                        React.createElement(StepControlButton, {
                            icon: iconPlus,
                            onClick: function onClick() {
                                _this2._handleAddStepAfter(i);
                            }
                        })
                    ),
                    React.createElement(Editor, {
                        ref: "editor" + i,
                        apiOptions: _this2.props.apiOptions,
                        content: json.content,
                        widgets: json.widgets,
                        images: json.images,
                        widgetEnabled: true,
                        immutableWidgets: false,
                        onChange: _.partial(_this2._handleEditorChange, i)
                    })
                );
            })
        );
    },

    _handleEditorChange: function _handleEditorChange(i, newProps) {
        var steps = _.clone(this.props.json);
        steps[i] = _.extend({}, steps[i], newProps);
        this.props.onChange({ json: steps });
    },

    serialize: function serialize() {
        var _this3 = this;

        return {
            json: _.times(this.props.json.length, function (i) {
                return _this3.refs["editor" + i].serialize();
            })
        };
    },

    _handleMoveStepEarlier: function _handleMoveStepEarlier(i) {
        if (i === 0) {
            return;
        }
        var steps = _.clone(this.props.json);
        var step = steps[i];
        steps.splice(i, 1);
        steps.splice(i - 1, 0, step);
        this.props.onChange({
            json: steps
        });
    },

    _handleMoveStepLater: function _handleMoveStepLater(i) {
        var steps = _.clone(this.props.json);
        if (i + 1 === steps.length) {
            return;
        }
        var step = steps[i];
        steps.splice(i, 1);
        steps.splice(i + 1, 0, step);
        this.props.onChange({
            json: steps
        });
    },

    _handleAddStepAfter: function _handleAddStepAfter(i) {
        // We do a full serialization here because we
        // might be copying widgets:
        var steps = _.clone(this.props.json);
        // Here we do magic to allow you to copy-paste
        // things from the previous section into the new
        // section while preserving widgets.
        // To enable this, we preserve the widgets
        // object for the new section, but wipe out
        // the content.
        var newStep = i >= 0 ? {
            widgets: steps[i].widgets
        } : {};
        steps.splice(i + 1, 0, newStep);
        this.props.onChange({
            json: steps
        });
    },

    _handleRemoveStep: function _handleRemoveStep(i) {
        var steps = _.clone(this.props.json);
        steps.splice(i, 1);
        this.props.onChange({
            json: steps
        });
    }
});

module.exports = SequenceEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/sequence-editor.jsx
 ** module id = 145
 ** module chunks = 0 1
 **/